import React from 'react';
import {
  emp,
  plataforma1,
  urlRedireccionP2pSuscripcion,
  urlSolicitarSuscripcionP2P
} from "../../constants/urls";
import publicIp from "public-ip";

export const useSolicitarSuscripcionRenovacion = () => {
  const {host, protocol} = window.location
  const setBody = async (idPoliza) => {
    console.log(idPoliza)
    return {
      empresa: emp,
      plataforma: plataforma1,
      idPoliza: idPoliza,
      ipAddress: await publicIp.v4(),
      userAgent: navigator.userAgent,
      urlBase: `${protocol}//${host}/`,
      urlRedireccion: urlRedireccionP2pSuscripcion
    }
  }


  return async (idPoliza) => {
    try {
      console.log('URL: ', urlSolicitarSuscripcionP2P)
      return await fetch(urlSolicitarSuscripcionP2P, {
        method: 'POST',
        body: JSON.stringify(await setBody(idPoliza))
      }).then(res => res.json())
    } catch (e) {
      return {transaccion: false}
    }
  }
}